module.exports = __webpack_public_path__ + "static/media/D2-Abzeichen-plus.daca17ba.png";